import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../utils/api";
import { normalizeClientDetailCategory } from "../../utils/clientDetailsCategory";

function resolveClientMessagesArg(arg) {
  if (arg == null) return { clientId: null, category: "individual" };
  if (typeof arg === "object") {
    return {
      clientId: arg.clientId ?? arg.client_id ?? null,
      category: normalizeClientDetailCategory(arg.category),
    };
  }
  return { clientId: arg, category: "individual" };
}

export const getClientMessages = createAsyncThunk(
  "message/getClientMessages",
  async (arg) => {
    const { clientId, category } = resolveClientMessagesArg(arg);
    if (!clientId) return { clientId: null, category, messages: [] };
    try {
      const qs = `?category=${encodeURIComponent(category)}`;
      const { data } = await API.get(
        `message/getClientMessages/${clientId}${qs}`,
      );
      return { clientId, category, messages: data?.data || [] };
    } catch (e) {
      return { clientId, category, messages: [] };
    }
  },
);

export const updateClientMessage = createAsyncThunk(
  "message/updateClientMessage",
  async ({ messageId, clientId, text, category = "individual" }) => {
    const { data } = await API.patch(
      `message/updateClientMessage/${messageId}`,
      { message: text },
    );
    return {
      clientId,
      category: normalizeClientDetailCategory(category),
      messageId,
      message: data?.data || null,
    };
  },
);

export const sendClientMessage = createAsyncThunk(
  "message/sendClientMessage",
  async ({ clientId, text, emailNotify = true, category = "individual" }) => {
    const normalizedCategory = normalizeClientDetailCategory(category);
    const payload = {
      client_id: clientId,
      message: text,
      category: normalizedCategory,
      email_notify: emailNotify,
    };
    const { data } = await API.post("message/sendClientMessage", payload);
    return {
      clientId,
      category: normalizedCategory,
      message: data?.data || null,
    };
  },
);

export const markClientThreadRead = createAsyncThunk(
  "message/markClientThreadRead",
  async ({ clientId, category = "individual" }) => {
    const normalizedCategory = normalizeClientDetailCategory(category);
    try {
      await API.post("message/markClientThreadRead", {
        client_id: clientId,
        category: normalizedCategory,
      });
      return { clientId, category: normalizedCategory };
    } catch (e) {
      return { clientId, category: normalizedCategory };
    }
  },
);

export const getUnreadMessageSummary = createAsyncThunk(
  "message/getUnreadMessageSummary",
  async () => {
    try {
      const { data } = await API.get("message/getUnreadMessageSummary");
      return data?.data || { unread_count: 0, threads: [] };
    } catch (e) {
      return { unread_count: 0, threads: [] };
    }
  },
);

export const getMessageThreads = createAsyncThunk(
  "message/getMessageThreads",
  async () => {
    try {
      const { data } = await API.get("message/getMessageThreads");
      return data?.data || { threads: [], total_count: 0 };
    } catch (e) {
      return { threads: [], total_count: 0 };
    }
  },
);
